import React from 'react'
import "./Success_race"

function Success_race() {
  return (
    <div>Success_race</div>
  )
}

export default Success_race